<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M9 9V13.5M9 13.5L11.25 12M9 13.5L6.75 12M9.75 2.25065C9.67838 2.25 9.59796 2.25 9.50604 2.25H6.15015C5.31007 2.25 4.88972 2.25 4.56885 2.41349C4.2866 2.5573 4.0573 2.7866 3.91349 3.06885C3.75 3.38972 3.75 3.81007 3.75 4.65015V13.3501C3.75 14.1902 3.75 14.61 3.91349 14.9309C4.0573 15.2132 4.2866 15.4429 4.56885 15.5867C4.8894 15.75 5.30925 15.75 6.14768 15.75H11.8523C12.6908 15.75 13.11 15.75 13.4305 15.5867C13.7128 15.4429 13.9429 15.2131 14.0867 14.9309C14.25 14.6104 14.25 14.1911 14.25 13.3527V6.99426C14.25 6.90222 14.25 6.82171 14.2493 6.75M9.75 2.25065C9.96423 2.2526 10.0998 2.26038 10.2291 2.29145C10.3822 2.32819 10.5284 2.38895 10.6626 2.47119C10.8139 2.56392 10.9439 2.69386 11.2031 2.95312L13.5472 5.29724C13.8067 5.55667 13.9357 5.68602 14.0284 5.83739C14.1107 5.9716 14.1715 6.11794 14.2083 6.271C14.2393 6.40032 14.2473 6.53588 14.2493 6.75M9.75 2.25065V4.35C9.75 5.19008 9.75 5.60983 9.91349 5.93069C10.0573 6.21294 10.2866 6.44286 10.5688 6.58667C10.8894 6.75 11.3092 6.75 12.1477 6.75H14.2493M14.2493 6.75H14.2501"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "PdfWhite",
};
</script>
